<template>
  <v-form
    v-model="valid"
    ref="form"
    lazy-validation
    class="pr-md-24"
    @submit.prevent="createUser"
    v-if="user"
  >
    <div class="d-flex justify-end mb-2">
      <v-btn tile color="primary" @click="$router.push({ name: 'user-index' })">
        <v-icon left>
          arrow_back
        </v-icon>
        Back
      </v-btn>
    </div>
    <v-card class="pa-4 px-4 mb-10 pr-md-24" elevation="0" outlined>
      <v-container>
        <v-row class="text-center">
          <v-col class="text-center" cols="12" md="6">
            <image-picker
              v-model="user.avatar"
              :add="user.avatar === null"
              :uploaded="user.avatar !== null"
              @delete-item="user.avatar = null"
              @reset="user.avatar = null"
              class="mb-5"
            >
              <div slot="activator" class="cursor-pointer w-100 h-100">
                <img
                  :src="user.avatar"
                  alt="avatar"
                  height="100%"
                  v-if="user.avatar"
                />
              </div>
            </image-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h2 class="group-label col-12 text-left px-0">
              General Information
            </h2>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :counter="35"
              outlined
              label="First Name"
              name="first name"
              v-model="user.firstName"
              :rules="nameRules"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :counter="20"
              outlined
              label="Last Name"
              name="last name"
              v-model="user.lastName"
              :rules="nameRules"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :counter="35"
              outlined
              label="Email"
              name="email"
              v-model="user.email"
              :rules="emailRules"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="user.userPositionId"
              :items="userPositions"
              outlined
              label="Select Position"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <hr />
          </v-col>
          <v-col cols="12">
            <h2 class="group-label col-12 text-left px-0">
              Account Information
            </h2>
          </v-col>
          <v-col cols="12" md="6">
            <v-switch
              class="p-0 mt-0 pt-0"
              v-model="user.active"
              hide-details
              inset
              label="Active/Inactive"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="6">
            <v-switch
              class="p-0 mt-0 pt-0"
              v-model="user.approved"
              hide-details
              inset
              label="Approved/Unapproved"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="user.role"
              :items="roles"
              :rules="roleRules"
              outlined
              label="Select Roles"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="user.supplierId"
              :items="suppliers"
              name="supplier"
              outlined
              label="Select Supplier"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :counter="35"
              label="GDC Number"
              outlined
              type="number"
              v-model="user.gdcNumber"
              :rules="gdcRules"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="user.type"
              :items="types"
              :rules="typeRules"
              outlined
              label="Select Types"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="user.surgeryId"
              :items="surgeries"
              outlined
              label="Select Surgery"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6">
            <v-tel-field
              :counter="35"
              label="Phone"
              type="number"
              v-model="user.phone"
              outlined
              name="phone"
              :rules="phoneRules"
            ></v-tel-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :counter="35"
              label="Password"
              v-model="user.password"
              outlined
              name="password"
              :rules="passwordRules"
              type="password"
            ></v-text-field>
          </v-col>
          <v-col></v-col>
        </v-row>
        <div class="text-left">
          <v-btn type="submit" color="accent" class="mx-0">Create</v-btn>
        </div>
      </v-container>
    </v-card>
  </v-form>
</template>
<script>
import { mapState } from "vuex";
import ImagePicker from "@/components/ImagePicker.vue";
export default {
  data() {
    return {
      valid: false,
      user: {
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        type: "",
        role: "",
        gdcNumber: "",
        supplierId: "",
        active: "",
        approved: "",
        userPositionId: "",
        avatar: null
      },
      types: ["employee", "owner"],
      roles: ["admin", "user"],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      nameRules: [
        v => !!v || "Name is required",
        v => v.length >= 3 || "Name must be at least 3 characters",
        v => v.length <= 35 || "Name must be less than than 35 characters"
      ],
      passwordRules: [
        v => !!v || "Password is required",
        v => v.length >= 6 || "Password must be at least 6 characters",
        v => v.length <= 15 || "Password must be less than than 15 characters"
      ],
      gdcRules: [
        v => !!v || "GdcNumber is required",
        v => v.length >= 8 || "GdcNumber must be at least 8 digits",
        v => v.length <= 20 || "GdcNumber must be less than than 20 digits"
      ],
      phoneRules: [
        v => !!v || "Phone is required",
        v => v.length >= 8 || "Phone must be at least 8 digits",
        v => v.length <= 20 || "Phone must be less than than 20 digits"
      ],
      typeRules: [v => !!v || "Type is required"],
      roleRules: [v => !!v || "Role is required"]
    };
  },
  components: {
    ImagePicker
  },
  async mounted() {
    this.$store.dispatch("suppliers/LOAD_SUPPLIERS", {
      from: 0,
      to: 0
    });
    await this.$store.dispatch("users/LOAD_USER_POSITIONS");
    this.$store.dispatch("surgeries/LOAD_SURGERIES", {
      from: 0,
      to: 0
    });
  },
  computed: {
    ...mapState({
      userPositions: state => state.users.user_positions,
      suppliers: state => state.suppliers.suppliers,
      surgeries: state => state.surgeries.surgeries
    })
  },
  methods: {
    async createUser() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Adding user...",
          html: "this will only take a moment",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("users/CREATE_USER", this.user);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "User has been added",
          icon: "info"
        });
      }
    }
  }
};
</script>
